module.exports = "/_next/static/images/environmentalAndGeotechnicalServices-0afb8112a287f3c8e01a68e5f3f8cc13.webp";